console.log( 'example script' );
